import { AppealStatusesEnum } from '../enums/AppealStatusesEnum';
import { IAppealStatusSelectOption } from '../interfaces/IAppealStatusSelectOption';

export const appealStatusSelectOptions: IAppealStatusSelectOption[] = [
  {
    id: AppealStatusesEnum.SEND,
    label: 'Жалоба направлена',
    value: AppealStatusesEnum.SEND,
  },
  {
    id: AppealStatusesEnum.PARTIALLY_APPROVE,
    label: 'В пользу заявителя (частично)',
    value: AppealStatusesEnum.PARTIALLY_APPROVE,
  },
  {
    id: AppealStatusesEnum.DENIED,
    label: 'Отказано в рассмотрении',
    value: AppealStatusesEnum.DENIED,
  },
  {
    id: AppealStatusesEnum.CONTROL,
    label: 'В пользу проверяющего',
    value: AppealStatusesEnum.CONTROL,
  },
  {
    id: AppealStatusesEnum.APPROVE,
    label: 'В пользу заявителя (полностью)',
    value: AppealStatusesEnum.APPROVE,
  },
];
